import { Path } from "@formily/path";
class EventBus {
    events;
    constructor(){
        this.events = {};
    }
    clear() {
        this.events = {};
    }
    emit(args) {
        const { rule } = args;
        Object.entries(this.events).forEach(([eventName, list])=>{
            if (Path.parse(rule).match(eventName)) list?.forEach((callback)=>{
                callback(args);
            });
        });
    }
    has(eventName, callback) {
        return (this.events[eventName] ? void 0 : false) ?? (callback ? this.events[eventName]?.includes(callback) : true) ?? false;
    }
    off(eventName, callback) {
        if (!Array.isArray(this.events[eventName])) return;
        if (callback) this.events[eventName] = this.events[eventName].filter((cb)=>cb !== callback);
        else this.events[eventName] = [];
        if (0 === this.events[eventName].length) Reflect.deleteProperty(this.events, eventName);
    }
    on(eventName, callback) {
        this.events[eventName] ??= [];
        if (!this.events[eventName].includes(callback)) this.events[eventName].push(callback);
    }
    once(eventName, callback) {
        const wrapper = (args)=>{
            callback(args);
            this.off(eventName, wrapper);
        };
        this.on(eventName, wrapper);
    }
}
const eventBus = new EventBus();
export { eventBus as default };
